<template>
  <div>
    <div class="fc-text-center">
    	<img class="paystatus_img" src="../assets/img/cancelIcon.png" >
    	<p class="paystatus_title">{{$t('m.PayStatusCancel_title')}}</p>

    	<div class="fc-btn-main backhomepage fc-mar-t-super" @click="goHome">{{$t('m.goBack')}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'cancel',
    data() {
      return {

      }
    },
    watch: {

    },
    filters: {

    },
    mounted() {
    },
    methods: {
      goHome(){
      	this.$router.push({
      	  path: '/'
      	})
      }

    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/cancel.vue